import ItemDetails from './ItemDetails';
import './ItemDetails.scss';

export default ItemDetails;